import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { FallaufgabenService } from '../services/fallaufgaben-service';

export const fallaufgabenResolver: ResolveFn<boolean> = async (route, state) => {
  const fallaufgabenService = inject(FallaufgabenService);

  try {
    await fallaufgabenService.list();
    if (route.params['fallaufgabenid']) {
      fallaufgabenService.set(route.params['fallaufgabenid']);
      await fallaufgabenService.get(route.params['fallaufgabenid']);
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};
